import { render, staticRenderFns } from "./InformacionEvento.vue?vue&type=template&id=ff3c5362&"
import script from "./InformacionEvento.vue?vue&type=script&lang=js&"
export * from "./InformacionEvento.vue?vue&type=script&lang=js&"
import style0 from "./InformacionEvento.vue?vue&type=style&index=0&id=ff3c5362&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports